import { Divider, Text } from '@doist/marketist';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUIAvatar } from '../product-ui-avatar/product-ui-avatar';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIActivityListItem, ProductUIBasicListItem, ProductUISidebarHeaderItem } from '../product-ui-list-item';
import { useProductUINSTranslation } from '../product-ui-ns-context';
import { ProductUIQuickAddButton } from '../product-ui-quick-add-button/product-ui-quick-add-button';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { ProductUISidebar, ProfileMenu, SideBarSection } from '../product-ui-sidebar/product-ui-sidebar';
import { ProductUIView } from '../product-ui-view/product-ui-view';
export function ActivityHistoryScene() {
  const {
    t
  } = useProductUINSTranslation();
  return <ProductUISceneContainer backgroundVariant="wave-three" data-sentry-element="ProductUISceneContainer" data-sentry-component="ActivityHistoryScene" data-sentry-source-file="activity-history.tsx">
            <ProductUISceneLayer position="bottomRight" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="activity-history.tsx">
                <ProductUIAppWindow inlineSize={808} showSidebar sidebar={<ProductUISidebar profileMenu={<ProfileMenu dailyProgress={0.7} />} views={<SideBarSection>
                                    <ProductUIQuickAddButton abstracted />
                                    <ProductUIBasicListItem icon="search" skeletonWidth="20" abstracted />
                                    <ProductUIBasicListItem icon="inbox" skeletonWidth="20" abstracted />
                                    <ProductUIBasicListItem icon="dateToday" skeletonWidth="20" abstracted />
                                    <ProductUICursorContainer size="lg">
                                        <ProductUIBasicListItem icon="complete" iconColor="theme" label={t('sequence.activityLog.completed')} active />
                                    </ProductUICursorContainer>
                                </SideBarSection>} workspaces={<>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="personal" abstracted={true} skeletonWidth="60" />
                                    </SideBarSection>
                                    <SideBarSection>
                                        <ProductUISidebarHeaderItem icon="team" abstracted={true} skeletonWidth="40" />
                                    </SideBarSection>
                                </>} />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="activity">
                                <ProductUIView.Header title={t('sequence.activityLog.activityAllProjects')} />
                                <ProductUIView.Section>
                                    <ProductUIView.SectionTitle>
                                        {t('today')}
                                    </ProductUIView.SectionTitle>
                                    <Divider />
                                    <ProductUIActivityListItem avatar={<ProductUIAvatar character="denise" checked />} label={<ActivityLogText actioner={t('sequence.activityHistory.you')} action={t('sequence.activityLog.addATask')} />} />
                                    <Divider />
                                    <ProductUIActivityListItem avatar={<ProductUIAvatar character="summer" checked />} label={<ActivityLogText actioner={t('characters.summer')} action={t('sequence.activityLog.completedATask')} />} />
                                </ProductUIView.Section>
                                <ProductUIView.Section>
                                    <ProductUIView.SectionTitle>
                                        {t('yesterday')}
                                    </ProductUIView.SectionTitle>
                                    <Divider />
                                    <ProductUIActivityListItem avatar={<ProductUIAvatar character="stijn" />} label={<ActivityLogText actioner={t('characters.stijn')} action={t('sequence.activityLog.completedATask')} />} />
                                    <Divider />
                                </ProductUIView.Section>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="activity-history.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
type ActivityLogTextProps = {
  actioner: string;
  action: string;
};
function ActivityLogText({
  actioner,
  action
}: ActivityLogTextProps) {
  return <span data-sentry-component="ActivityLogText" data-sentry-source-file="activity-history.tsx">
            <Text tag="strong" size="minor-base" weight="semibold" data-sentry-element="Text" data-sentry-source-file="activity-history.tsx">
                {actioner}
            </Text>{' '}
            <Text size="minor-base" weight="medium" tag="span" style={{
      color: 'var(--display-onlight-secondary)'
    }} data-sentry-element="Text" data-sentry-source-file="activity-history.tsx">
                {action}
            </Text>
        </span>;
}